export default __webpack_public_path__ + "static/media/facebook.0c1e69c3.svg";